































import { Component, Vue, Prop } from 'vue-property-decorator'
import { ValidationProvider } from 'vee-validate'

import { localize } from "vee-validate"

@Component({
  components: {
    ValidationProvider
  },
  name: 'CheckBox'
})
export default class Checkbox extends Vue {

  @Prop({required: false, default: undefined}) vid!: string
  @Prop({required: true, default: ""}) name!: string
  @Prop({required: false, default: ""}) label!: string
  @Prop({required: false, default: ""}) rules!: string[] | object[]
  @Prop({required: true, default: false}) value!: boolean

  get innerValue(): boolean {
    return this.value
  }

  set innerValue(value: boolean) {
    this.$emit('input', value)
  }

  created(): void {

    // Validation custom messages - localise the names.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const names: any = {}

    names[this.name] = this.label || this.name

    localize({
      en: {
        names
      },
    })
  }
}
